import Service from "../service";
import AuthService from "../AuthService";

const Event = {
    getEvent(data) {
        return AuthService.get("/event?page="+data.page+
          "&field="+data.field+
          "&sorttype="+data.sorttype+
          "&start_date="+data.start_date+
          "&end_date="+data.end_date+
          "&area_id="+data.area_id+
          "&user_type_id="+data.user_type_id+
          "&province_id="+data.province_id+
          "&hospital_code="+data.hospital_code+
          "&district_id="+data.district_id);
    },
    showEventById(id, options = {}) {
        const query = options.skipLog ? '?skip_log=1' : '';
        return AuthService.get("/event_show/" + id + query);
    },
    updateEvent(id, data) {
        return AuthService.post("/event_update/" + id, data)
    },
    createEvent(data) {
        return AuthService.post("/event", data);
    },
    deleteEvent(id) {
        return AuthService.delete("/event/" + id);
    },
    countPatient(){
        return AuthService.get('/count_patient');
    },
    // searchEvent(data){
    //     return Service.post('/search_event',data);
    // },
    searchEvent(data){
        return AuthService.get(`/search_event?page=${data.page}&field=${data.field}&sorttype=${data.sorttype}&name=${data.name}&province_id=${data.province_id}&start_date=${data.start_date}&end_date=${data.end_date}`);
    },
    getEventAll(){
        return AuthService.get('/get_event_all');
    },
};

export default Event;
